// extracted by mini-css-extract-plugin
export default {"table":"Equipments_table__qcOMh","search":"Equipments_search__jnVjo"};